import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * CollectParams.ts
 */
export class CollectParams {
    constructor(messageAcknowledged) {
        this.messageAcknowledged = messageAcknowledged;
    }
    liquify() {
        let data = new DataObject();
        data.putBoolean(SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED, this.messageAcknowledged);
        return data;
    }
}
//# sourceMappingURL=CollectParams.js.map